import React from 'react';
import { highlightParts } from '../utils/kernelSearch';
import './kernelSearch.css';

/**
 * Testo con le parole cercate evidenziate (`terms` viene da searchTerms). Senza parole mostra il testo così com'è.
 * Il risultato è un unico <span>: dentro un contenitore flessibile con `gap` i pezzi del testo non
 * diventano elementi separati (altrimenti la parola sembrerebbe spezzata da uno spazio).
 */
function KernelHighlight({ text, terms }) {
  if (!terms || terms.length === 0) return <>{text}</>;
  return (
    <span>
      {highlightParts(text, terms).map((part, i) => (
        part.match ? <mark key={i} className="khl">{part.text}</mark> : <React.Fragment key={i}>{part.text}</React.Fragment>
      ))}
    </span>
  );
}

export default KernelHighlight;
